<script lang="ts">
    import ZentitySelect from '../../_common/z/zentity-select.svelte'
    import { onMount } from 'svelte'
    import Fa from 'svelte-fa'
    import { faCopy, faRefresh } from '@fortawesome/free-solid-svg-icons'
    import type { List } from '../../../modules/pipelineApi/pipeline/lists/list'
    import type { User } from '../../../modules/usersApi/users/user'

    export let list: List

    let user: User = null
    let loaded = false
    onMount(async () => {
        await updateLink()
        loaded = true
    })

    let link: string = ''
    function updateLink() {
        if (!user?.userId) {
            link = ''
            return
        }
        link = 'https://pipelines-api.zandu.com.br/public/?token=' + list.token + '&user=' + user.userId
        console.log('link', link)
    }

    function copyLink() {
        if (!link) return
        window.api.utils.utils.copyToClipboard(link)
        window.alert('Link copiado')
    }

    async function resetLink() {
        if (!confirm('Deseja mesmo resetar este link?\nO link atual deixará de funcionar.')) return
        await window.api.pipelines.lists(list.boardId).resetToken(list.listId)
        await updateLink()
    }
</script>

{#if loaded}
    <div class="root m-3">
        <div class="config-box">
            <p>Faça com que aplicações externas gerem novos cartões em seu pipeline do Zandu.</p>
            <div class="row">
                <div class="col">
                    <ZentitySelect fonte="usuario" label="Usuário de destino" bind:value={user} on:change={updateLink} />
                </div>
            </div>
            <div class="row">
                <div class="col pt-2">
                    <div class="date input-group">
                        <label for="" class="input-group-text">Link de integração POST</label>
                        <input type="text" class="form-control" bind:value={link} />
                        <button on:click={resetLink} class="btn btn-warning"><Fa icon={faRefresh} /></button>
                        <button on:click={copyLink} class="btn btn-primary"><Fa icon={faCopy} /> Copiar link</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <pre><code>
{`{
    "title": "Título obrigatório do cartão",
    "text": "Texto livre opcional \\n com quebra de linha",
    "personPhone": "551020203030",
    "personName": "João da Silva",
    "personEMail": "João da Silva"
}`}</code
                        ></pre>
                </div>
            </div>
        </div>
        <div class="config-box mt-3">
            <p>Faça um POST para a URL acima com o corpo de exemplo para criar um cartão.</p>
            <p>
                O único campo ogrigatório é o <code>title</code><br />
                Uma pessoa é selecionada ou criada caso <code>personPhone</code> seja informado.
            </p>
        </div>
    </div>
{/if}

<style>
</style>
